import React from "react";
import { Icon, IconProps } from "../Icon";
/**
 * @group Icons
 */
export function NotificationImportantIcon(props: IconProps) {
    return <Icon {...props} iconKey={"notification_important"}/>
}
